import { render, staticRenderFns } from "./EditRate.vue?vue&type=template&id=3d6da715&scoped=true"
import script from "./EditRate.vue?vue&type=script&lang=js"
export * from "./EditRate.vue?vue&type=script&lang=js"
import style0 from "./EditRate.vue?vue&type=style&index=0&id=3d6da715&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d6da715",
  null
  
)

export default component.exports